module.exports = __webpack_public_path__ + "static/smile-face-7-1908427de0c47a0960a7864765a9ce4a.jpg";